export const NOTIFICATION_SEVERITY_ICONS = {
  info: 'circle-info',
  warning: 'triangle-exclamation',
  action_required: 'diamond-exclamation',
  urgent: 'siren',
} as const;

export const NOTIFICATION_SEVERITY_COLORS = {
  info: 'text-[#AFBCD8]',
  warning: 'text-[#AFBCD8]',
  action_required: 'text-[#E2A336]',
  urgent: 'text-[#E54D2E]',
} as const;

export const NOTIFICATION_SEVERITY_BADGE_COLORS = {
  info: 'neutral',
  warning: 'neutral',
  action_required: 'warning',
  urgent: 'error',
} as const;
